<template>
  <div class="success-show">
    <div class="top-bg"></div>
    <div class="content">
      <div class="big-title">成功案例展示</div>
      <div class="search">
        <div class="search-input">
          <el-input v-model.trim="keyword" placeholder="输入项目名称进行检索"></el-input>
        </div>
      </div>

      <!-- 典型案例：非地图类型的项目 -->
      <section class="section">
        <div class="section-title">典型案例</div>
        <div class="list">
          <div class="left">类型</div>
          <div class="right">
            <div class="right-item" :class="{ 'right-check': caseType === '' }" @click="caseType = ''">全部</div>
            <div v-for="item in typeList" :key="item.value" class="right-item" :class="{ 'right-check': caseType === item.value }" @click="caseType = item.value">
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="body">
          <common-loading v-if="caseLoading" text="案例加载中" />
          <ul v-else-if="filteredCases.length" class="ul">
            <project-card v-for="item in filteredCases" :key="item.id" :item="item" />
          </ul>
          <div v-else class="empty">
            <div class="empty-title">未找到匹配案例</div>
            <div class="empty-text">试试调整筛选条件或输入其他关键词。</div>
          </div>
        </div>
      </section>

      <!-- 地图详解：地图类型的项目 -->
      <section class="section">
        <div class="section-title">地图详解</div>
        <div class="list">
          <div class="left">地图</div>
          <div class="right">
            <div class="right-item" :class="{ 'right-check': mapType === '' }" @click="mapType = ''">全部</div>
            <div v-for="item in mapTypeList" :key="item.value" class="right-item" :class="{ 'right-check': mapType === item.value }" @click="mapType = item.value">
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="body">
          <common-loading v-if="mapLoading" text="地图加载中" />
          <ul v-else-if="filteredMaps.length" class="ul">
            <project-card v-for="item in filteredMaps" :key="item.id" :item="item" />
          </ul>
          <div v-else class="empty">
            <div class="empty-title">未找到匹配案例</div>
            <div class="empty-text">试试调整筛选条件或输入其他关键词。</div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getCasePage, getMapPage, getMapTypeSimpleList, getTypeSimpleList, PAGE_SIZE_MAX } from '@/api/webProject';
import CommonLoading from '@/components/CommonLoading';
import ProjectCard from './ProjectCard.vue';

export default {
  name: 'SuccessShow',
  components: {
    CommonLoading,
    ProjectCard
  },
  data() {
    return {
      keyword: '',
      // 典型案例
      typeList: [],
      caseType: '',
      caseList: [],
      caseLoading: true,
      // 地图详解
      mapTypeList: [],
      mapType: '',
      mapList: [],
      mapLoading: true
    };
  },
  computed: {
    filteredCases() {
      return this.filterList(this.caseList, item => !this.caseType || item.type === this.caseType);
    },
    filteredMaps() {
      return this.filterList(this.mapList, item => !this.mapType || item.mapType === this.mapType);
    }
  },
  created() {
    this.loadTypes();
    this.loadCases();
    this.loadMapTypes();
    this.loadMaps();
  },
  methods: {
    // 一次按上限拉取，类型筛选和名称检索都在前端做
    // 接口需要登录，令牌失效时拦截器会自动刷新或跳登录页，这里只需保证不产生未捕获的 rejection
    async loadCases() {
      try {
        const page = await getCasePage({ pageNo: 1, pageSize: PAGE_SIZE_MAX });
        this.caseList = (page && page.list) || [];
      } catch (e) {
        this.caseList = [];
      } finally {
        this.caseLoading = false;
      }
    },
    async loadMaps() {
      try {
        const page = await getMapPage({ pageNo: 1, pageSize: PAGE_SIZE_MAX });
        this.mapList = (page && page.list) || [];
      } catch (e) {
        this.mapList = [];
      } finally {
        this.mapLoading = false;
      }
    },
    async loadTypes() {
      try {
        this.typeList = (await getTypeSimpleList()) || [];
      } catch (e) {
        this.typeList = [];
      }
    },
    async loadMapTypes() {
      try {
        this.mapTypeList = (await getMapTypeSimpleList()) || [];
      } catch (e) {
        this.mapTypeList = [];
      }
    },
    filterList(list, matchFilter) {
      const keyword = this.keyword;
      return list.filter(item => {
        const matchName = !keyword || (item.name || '').indexOf(keyword) >= 0;
        return matchName && matchFilter(item);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.success-show {
  position: relative;
  min-height: 100vh;
  background: #0b0d10;

  .top-bg {
    position: absolute;
    width: 100%;
    height: 530px;
    background: #0b0d10 url('../img/case-top-bg.png') no-repeat 50%;
    background-size: 100% 530px;
  }

  .content {
    position: relative;
    width: calc(100vw - 48px);
    max-width: 1440px;
    margin: 0 auto;
    padding: 100px 0 80px;
  }

  .big-title {
    color: #fff;
    font-size: 48px;
  }

  .search {
    margin-top: 80px;
  }

  .search-input {
    padding: 5px 0;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50px;
  }

  ::v-deep .el-input__inner {
    color: #fff;
    text-align: center;
    background: transparent;
    border: 1px solid transparent;
  }

  ::v-deep .el-input__inner::placeholder {
    color: rgba(255, 255, 255, 0.42);
  }

  .section {
    margin-top: 60px;
  }

  .section-title {
    color: #fff;
    font-size: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }

  .list {
    display: flex;
    align-items: center;
    color: #fff;
    margin-top: 25px;
  }

  .left {
    width: 80px;
    margin-right: 30px;
    font-size: 16px !important;
    line-height: 32px;
    flex-shrink: 0;
  }

  .right {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .right-item {
    min-width: 80px;
    height: 32px;
    padding: 0 14px;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 24px;
    cursor: pointer;
  }

  .right-item:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  .right-item.right-check {
    background: #008dff;
  }

  .right-item.right-check:hover {
    background: #008dff;
  }

  .body {
    padding: 40px 0 0;
  }

  .tip {
    min-height: 160px;
    color: rgba(255, 255, 255, 0.52);
    font-size: 14px;
    text-align: center;
    line-height: 160px;
  }

  .ul {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 40px 32px;
  }

  .empty {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 260px;
    color: rgba(255, 255, 255, 0.74);
    text-align: center;
  }

  .empty-title {
    font-size: 20px;
    color: #fff;
  }

  .empty-text {
    margin-top: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.52);
  }
}

@media (max-width: 1024px) {
  .success-show {
    .content {
      width: calc(100vw - 32px);
      padding-top: 68px;
    }

    .list {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .left {
      width: auto;
      margin-right: 0;
    }

    .ul {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}
</style>
